import { getActivityValue } from 'modules/activities-management';

export function isActivityTypeOneOf (activity, matchTypes = []) {
  const { type } = activity;
  const types = Array.isArray(matchTypes)
    ? matchTypes
    : [matchTypes];

  return types.includes(type);
}

// TODO: need tests
/**
 * getActivitiesInfo
 * Given an array of activities, return an array with all activities data
 *
 * @param {array} activities
 * @returns {array} array of activities
 */
export function getActivitiesInfo (activities, activityTypes) {
  if (activities) {
    return activities.map(activity => {
      if (activity.type) {
        const [, itemType] = activity.type.split(',');
        const { categoryLabel, controls, label } = getActivityValue(activityTypes, itemType);
        const { filters: activityFilters } = controls.find(({ type }) => type === 'location') || {};
        return {
          value: itemType,
          label: categoryLabel,
          category: label,
          uid: activity.uid,
          filters: activityFilters,
          ...activity,
        };
      }
      return null;
    });
  }
  return [];
}

/**
 * Get current activity map filters
 * @param {string} type of activity
 * @returns map filters of current activity
 */
export const getFilters = (type, activityTypes) => {
  if (!type) return [];

  const [, activityName] = type.split(',');
  return getActivityValue(activityTypes, activityName)
    .controls.find(({ type: controlType }) => controlType === 'location').filters;
};

export const getAllActivityDates = activity =>
  activity.eventDates.reduce((acc, { dates = [] }) => [...acc, ...dates], []);

export const getAllActivitiesDates = activities =>
  activities.reduce((store, activity) => [
    ...store,
    ...getAllActivityDates(activity),
  ], []);

// Il faut que ces délais soient dans le FMS
const DELAYS_BY_TYPES = [{
  types: [
    'sportEvent,hiking',
    'sportEvent,cycling',
    'sportEvent,horseRiding',
    'sportEvent,climbing',
    'sportEvent,orienteeringRun',
    'sportEvent,orienteeringCycle',
    'schoolOuting,sporting',
    'schoolOuting,noSporting',
    'noSportingOtherEvent,cultureEvent',
    'noSportingOtherEvent,religiousEvent',
    'noSportingOtherEvent,familyEvent',
  ],
  delays: [{
    value: true,
    minParticipants: 0,
    maxParticipants: 59,
  }, {
    value: 15,
    minParticipants: 60,
    maxParticipants: 149,
  }, {
    value: 30,
    minParticipants: 150,
    maxParticipants: 299,
  }, {
    value: 45,
    minParticipants: 300,
    maxParticipants: +Infinity,
  }],
}, {
  types: [
    'shooting,film',
    'shooting,camera',
  ],
  delays: [{
    value: 5,
    minParticipants: 0,
    maxParticipants: +Infinity,
  }],
}];
export function getAnswerDelay (activities) {
  return activities.reduce((prevValue, { type, participantCount, publicCount }) => {
    const { delays } = DELAYS_BY_TYPES.find(({ types }) => types.includes(type)) || {};

    if (!delays) return prevValue;

    const participants = Number(participantCount) + Number(publicCount);
    const { value } = delays.find(({ minParticipants, maxParticipants }) => (
      participants >= minParticipants &&
      participants <= maxParticipants
    ));

    return value;
  }, false);
}

export const getLabels = activityTypes =>
  activityTypes.reduce((acc, activi) => (
    acc.some(a => a.value === activi.value.category)
      ? acc
      : [
        ...acc,
        {
          value: activi.value.category,
          label: activi.value.categoryLabel,
          children: activityTypes.reduce((ac, activ) => {
            if (activi.value.category === activ.value.category) {
              return [...ac, { value: activ.key.split('.')[2], label: activ.value.label }];
            }
            return ac;
          }, []),
        },
      ]), []);

export const getAllTypes = activities => activities.reduce((acc, { type }) =>
  (acc.includes(type) ? acc : [...acc, type.split(',')[1]]), []);

export const getUserrequestSchema = (activities, userrequestSchema) =>
  userrequestSchema.filter(({ key }) =>
    getAllTypes(activities).includes(key.split('onf.fms.')[1]));

export default getActivitiesInfo;



// WEBPACK FOOTER //
// ./src/helpers/activityHelpers.js